/* global chrome */
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { I18nextContext, Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next'

import * as yup from 'yup'
import { AllAnimationsCombined } from '../../../components/Animation/Animation'
import { Button } from '../../../components/Button/Button'
import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL } from '../../../components/Footer'
import Images from '../../../images'
// import { I18nextContext, Link, useI18next } from 'gatsby-plugin-react-i18next';
import { useApiBase } from '../../../services/api'
import {
  getAndRedirectUser,
  getAuth0Errors,
  saveAndSendAuthDataToExtension,
  useAuth0
} from '../../../services/auth0/useAuth0'
import { trackEvent } from '../../../services/helpers'
import '../../../styles/style.scss'
import { Error, SingleField } from '../../Landing/Contact'
import { StyledLogo } from '../Onboarding/styled'
import { SocialMedia } from '../SocialMedia/SocialMedia'
import { Footer, ForgotPasswordLink, HeaderTitle } from './commons'
import { StyledSpan } from './styled'
import flagPl from 'svg-country-flags/svg/pl.svg'
import flagUs from 'svg-country-flags/svg/us.svg'
import { chromeSendMessage } from '../../../services/chrome'

const MobileAccessInfo = ({ type }) => {
  const { t } = useTranslation()
  if (type === 'register') {
    return (
      <div style={{ background: '#EAF3FF', borderRadius: 8, padding: '12px 16px', marginTop: 32 }}>
        <p style={{ fontSize: 13, fontWeight: 500, color: '#6297FF', fontFamily: 'Poppins', lineHeight: '156%' }}>
          {t('register.extensionInformation')}
        </p>
      </div>
    )
  }
  return null
}

export const LanguageDropdown = (props) => {
  const context = React.useContext(I18nextContext);
  const { originalPath, navigate } = useI18next();

  const currentFlag = context.language.toUpperCase()
  const onClick = (language) => () => {
    chromeSendMessage({
      type: 'extensionLanguage',
      language: language,
    })
  }
  return (
    <div className="dropdown is-hoverable">
      <div className="dropdown-trigger">
        <button style={{
          background: 'white',
          border: '1px solid #D5DEF1',
          borderRadius: 8,
          width: 44,
          height: 44,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
                aria-haspopup="true"
                aria-controls="dropdown-menu3"
        >
          <img src={currentFlag === 'PL' ? flagPl : flagUs} style={{ width: 25, height: 16 }}/>
        </button>
      </div>
      <div className="dropdown-menu" id="dropdown-menu3" role="menu">
        <div className="dropdown-content">
          <Link to={originalPath} onClick={onClick('pl')} language="pl" className="dropdown-item"
                style={{ display: 'flex', alignItems: 'center' }}>
            <img src={flagPl} style={{ width: 25, height: 16 }}/>
            <span className="has-text-weight-semibold" style={{ marginLeft: 8 }}>Polski</span>
          </Link>
          <Link to={originalPath} language="en" onClick={onClick('en')} className="dropdown-item"
                style={{ display: 'flex', alignItems: 'center' }}>
            <img src={flagUs} style={{ width: 25, height: 16 }}/>
            <span className="has-text-weight-semibold" style={{ marginLeft: 8 }}>English</span>
          </Link>

        </div>
      </div>
    </div>
  )
}


export const Auth = (props) => {
  const { type } = props
  const { t } = useTranslation();
  const { navigate } = useI18next();

  const loginValidationSchema = yup.object({
    email: yup
      .string(t('auth.email.enterEmail'))
      .email(t('auth.email.invalidEmail'))
      .required(t('auth.email.enterEmail')),
    password: yup
      .string('Wpisz swoje hasło')
      .required('Wpisz swoje hasło'),
  });

  const registerValidationSchema = yup.object({
    email: yup
      .string(t('auth.email.enterEmail'))
      .email(t('auth.email.invalidEmail'))
      .required(t('auth.email.enterEmail')),
    password: yup
      .string(t('auth.email.enterPassword'))
      .min(6, t('auth.email.invalidPassword'))
      .required(t('auth.email.enterPassword'))
  });

  const REGISTRATION_FIELDS = [
    {
      name: 'email',
      label: t('auth.email'),
      placeholder: t('auth.email.placeholder'),
      inputType: 'input',
      value: '',
      fieldHint: null
    },
    {
      name: 'password',
      label: t('auth.password'),
      placeholder: t('auth.password.placeholder'),
      inputType: 'password',
      value: '',
      fieldHint: type === "register" ? t("auth.password.fieldHint") : null
    },
  ]

  const api = useApiBase()
  const { initializedWebAuth0 } = useAuth0()
  const [isLoading, setIsLoading] = useState(false)
  const [mainError, setMainError] = useState(null)
  const [marketingCheckbox, setMarketingCheckbox] = useState(false)
  const [privacyPolicyCheckbox, setPrivacyPolicyCheckbox] = useState(false)

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: type === "register" ? registerValidationSchema : loginValidationSchema,
    onSubmit: (values) => {
      setIsLoading(true)
      if (type === "register") {
        const userData = {
          ...values,
          connection: 'Username-Password-Authentication'
        }
        initializedWebAuth0.signupAndAuthorize(userData, callbackFunction)
      } else {
        const userData = {
          ...values,
          username: values.email,
          realm: 'Username-Password-Authentication',
          scope: 'openid email profile offline_access',
        }
        initializedWebAuth0.client.login(userData, (err, authResult) => {
          callbackFunction(err, authResult)
        })
      }
    },
  });

  const callbackFunction = (e, data) => {
    if (e) {
      setIsLoading(false)
      setMainError(getAuth0Errors(e))
    } else {
      if (type === "register") {
        trackEvent("Account Created")
      }
      saveAndSendAuthDataToExtension(
        data.accessToken,
        data.refreshToken,
        new Date().getTime() + data.expiresIn * 1000,
        data.idToken
      )
      getAndRedirectUser(api, data.accessToken, data.idToken, navigate, "email")
    }
  }

  return (
    <div>
      <AllAnimationsCombined singlePage />
      <div className="container" style={{ height: '100vh' }}>
        <div className="columns">
          <div className="column is-justify-content-center is-flex" style={{ marginTop: 80, alignItems: 'center', position: 'relative' }}>
            <div>
              <StyledLogo
                src={Images.logoYellowWhite}
                srcSet={`${Images.logoYellowWhite3x} 3x, ${Images.logoYellowWhite2x} 2x`}
              />
            </div>
            <div style={{ marginTop: -10, position: 'absolute', left: '50%', marginLeft: 140 }}>
              <LanguageDropdown />
            </div>

          </div>

        </div>

        <div className="columns is-flex is-justify-content-center mt-0">
          <div className="column is-flex is-justify-content-flex-start is-flex-direction-column	" style={{ maxWidth: 424 }}>
            <HeaderTitle type={type} />
            <form style={{ width: '100%' }} onSubmit={formik.handleSubmit}>

              <Error withBorder text={t(mainError)} />
              {REGISTRATION_FIELDS.map(item => {
                return (
                  <SingleField
                    key={item.name}
                    isErrorVisible={formik.touched[item.name] && formik.errors[item.name]}
                    fieldError={formik.touched[item.name] && formik.errors[item.name] && formik.errors[item.name]}
                    fieldHint={item.fieldHint}
                    inputProps={{
                      onBlur: formik.handleBlur,
                      name: item.name,
                      label: item.label,
                      placeholder: item.placeholder,
                      inputType: item.inputType,
                      handleChangeField: formik.handleChange,
                      value: formik.values[item.name]
                    }}
                  />
                )
              })}
              <ForgotPasswordLink type={type} />
              {type === "register" && (
                <>
                  
                  <span target="_blank" href={PRIVACY_POLICY_URL} style={{ color: '#1E222D', fontSize: 11, display: 'inline-block', lineHeight: '156%', marginTop: 8 }}>
                    {t("auth.terms.firstLine")}
                    <StyledSpan href={TERMS_OF_USE_URL} target="_blank"> {t('auth.terms.terms')}</StyledSpan> {t('auth.terms.and')} <StyledSpan href={PRIVACY_POLICY_URL} target="_blank">{t('auth.terms.privacyPolicy')}</StyledSpan> {t("underline")}
                  </span>
                  <p style={{ color: '#1E222D', fontSize: 11, display: 'inline-block', lineHeight: '156%', marginTop: 16, marginBottom: 16 }}>
                    {t('auth.register.marketing')}
                  </p>
                </>
              )}

              <Button disabled={!formik.isValid} className={`${isLoading && 'is-loading'} `}
                      style={{ marginTop: 8, width: '100%' }} type="submit">
                {type === 'register' ? t('auth.register') : t('auth.login')}
              </Button>

            </form>
            <SocialMedia/>

            <Footer type={type}/>
          </div>
        </div>
      </div>
    </div >
  )
}
